// Sets globals on window before any vendor/coffee scripts read them
// at module initialization time. Must be imported FIRST in pack
// entrypoints due to ES module import hoisting.
//
// NOTE: This only covers globals read while a *pack entrypoint* initializes.
// The coffee behaviours also reference `$` at module scope, and they end up in
// shared chunks which the browser evaluates before the entrypoint body below,
// so jquery is injected into them by rolldown instead, see vite.config.mts.
//
// NOTE: Only for packs that own their jQuery. The pages rendered by
// cam_backend layouts already get jQuery from its `simple` pack, importing
// this there would put a second jQuery instance on the page.
import './jquery_globals'

import __Rails__ from '@rails/ujs'
import __lodash__ from 'lodash'
import __PDFObject__ from 'pdfobject'

Object.assign(window, {
  _: __lodash__,
  PDFObject: __PDFObject__,
  Rails: __Rails__
})

// rails-ujs starts itself when its compiled UMD sees `this === window`, which
// depends on how its CommonJS wrapper binds `this`: it does in development,
// but not in the bundled build. So only start it if that has not happened.
if (!window._rails_loaded) __Rails__.start()
